import { Component, Input } from '@angular/core';

@Component({
  selector: 'ff-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.scss']
})
export class ToggleComponent {

  /**
   * This function will be call when the user changed the toggle,
   * the toggle will emit the entire html event to be handle
   * in the parent component.
   * @internal
   */
  @Input() changeState: Function;
  @Input() isDisabled: boolean = false;
  constructor() { }

  onChange = (event: Event): void => {
    this.changeState(event);
  }

}
